export type CoachCardStatus =
  | "NEW"
  | "IN_DISCUSSION"
  | "DISCUSSED"
  | "DISMISSED";

export type CardSignalType =
  | "NEEDS_CLARITY"
  | "MISSING_EVIDENCE"
  | "ACTION_NEEDED"
  | "OPPORTUNITY"
  | "CHECK_IN";

export type CardWeight = "KEY_FOCUS" | "WORTH_DISCUSSING" | "IF_TIME_ALLOWS";

export enum CardFieldType {
  WhyItMatters = 1,
  WatchOut = 2,
  DesiredOutcome = 3,
  Prompt = 4,
}

export interface CardField {
  fieldType: CardFieldType;
  content: string;
  sortOrder: number;
}

export interface PriorityCard {
  id: number;
  title: string;
  status: CoachCardStatus;
  signalType: CardSignalType;
  weight: CardWeight;
  sortOrder: number;
  fields: CardField[];
}

export interface CoachParticipants {
  employeeName: string;
  managerName: string;
}
